// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Card        = require("./Card");
var List        = require("bs-platform/lib/js/list.js");
var $$Array     = require("bs-platform/lib/js/array.js");
var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var GiphyApi    = require("./GiphyApi");
var WinModal    = require("./WinModal");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

(( require('./App.css') ));

var component = ReasonReact.reducerComponent("App");

function make() {
  var initGame = function (self) {
    var handleGIFsLoaded = Curry._1(self[/* reduce */1], (function (gifData) {
            return /* Loaded */Block.__(0, [gifData]);
          }));
    GiphyApi.fetchGifs(/* () */0).then((function (repoData) {
            Curry._1(handleGIFsLoaded, repoData);
            return Promise.resolve(/* () */0);
          }));
    return /* () */0;
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function (self) {
      initGame(self);
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      var cards = $$Array.map((function (cardItem) {
              return ReasonReact.element(/* Some */[cardItem[/* id */0]], /* None */0, Card.make(cardItem, /* Some */[List.exists((function (item) {
                                      return +(item[/* id */0] === cardItem[/* id */0]);
                                    }), self[/* state */2][/* selected */1])], (function () {
                                return Curry._1(self[/* send */4], /* Select */Block.__(1, [cardItem]));
                              }), /* array */[]));
            }), self[/* state */2][/* data */0]);
      return React.createElement("div", {
                  className: "App"
                }, React.createElement("section", {
                      className: "App-header hero is-medium is-primary is-bold"
                    }, React.createElement("div", {
                          className: "hero-body"
                        }, React.createElement("div", {
                              className: "container"
                            }, React.createElement("h1", {
                                  className: "title"
                                }, "Memory cards game"), React.createElement("h2", {
                                  className: "subtitle"
                                }, "but with GIFs and ReasonML")))), React.createElement("section", {
                      className: "App-board section"
                    }, React.createElement("div", {
                          className: "container"
                        }, ReasonReact.element(/* None */0, /* None */0, WinModal.make(/* Some */[self[/* state */2][/* isGameOver */2]], (function () {
                                    return initGame(self);
                                  }), /* array */[])), cards)));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* data : array */[],
              /* selected : [] */0,
              /* isGameOver : false */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (typeof action === "number") {
        var match = state[/* selected */1];
        if (match) {
          var match$1 = match[1];
          if (match$1) {
            if (match$1[1]) {
              return /* NoUpdate */0;
            } else {
              var cardB = match$1[0];
              var cardA = match[0];
              if (cardA[/* value */1] === cardB[/* value */1]) {
                var newData = $$Array.map((function (card) {
                        var newrecord = card.slice();
                        newrecord[/* isGuesed */2] = card[/* isGuesed */2] || +(card[/* id */0] === cardA[/* id */0] || card[/* id */0] === cardB[/* id */0]);
                        return newrecord;
                      }), state[/* data */0]);
                var isGameOver = List.for_all((function (card) {
                        return card[/* isGuesed */2];
                      }), $$Array.to_list(newData));
                return /* Update */Block.__(0, [/* record */[
                            /* data */newData,
                            /* selected : [] */0,
                            /* isGameOver */isGameOver
                          ]]);
              } else {
                return /* Update */Block.__(0, [/* record */[
                            /* data */state[/* data */0],
                            /* selected : [] */0,
                            /* isGameOver */state[/* isGameOver */2]
                          ]]);
              }
            }
          } else {
            return /* NoUpdate */0;
          }
        } else {
          return /* NoUpdate */0;
        }
      } else if (action.tag) {
        var card = action[0];
        var length = List.length(state[/* selected */1]);
        if (length !== 1) {
          return /* Update */Block.__(0, [/* record */[
                      /* data */state[/* data */0],
                      /* selected : :: */[
                        card,
                        /* [] */0
                      ],
                      /* isGameOver */state[/* isGameOver */2]
                    ]]);
        } else {
          return /* UpdateWithSideEffects */Block.__(3, [
                    /* record */[
                      /* data */state[/* data */0],
                      /* selected : :: */[
                        card,
                        state[/* selected */1]
                      ],
                      /* isGameOver */state[/* isGameOver */2]
                    ],
                    (function (self) {
                        setTimeout((function () {
                                return Curry._1(self[/* send */4], /* Validate */0);
                              }), 500);
                        return /* () */0;
                      })
                  ]);
        }
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* data */action[0],
                    /* selected : [] */0,
                    /* isGameOver : false */0
                  ]]);
      }
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/App.re
// module id = 29
// module chunks = 0